// Trigger Group Sub Tab(2700489754)
/*
Sohel 10/12/2022 2700430604 Added code Validation and Autosuggestion
Sohel 10/14/2022 2700430604 Added Comments
Ashraf  10/28/2022  2700430604 moved main tabs to header
Raghu 10/28/2022 2700430604 Card Styling Fixes
Prakash 11/21/2022 2700430604 Added card.
Sohel 11/23/2022 2700271704 Added Alert Popup
Prakash 12/06/2022 2700271704 Removed margin spacing.
*/
import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {ThemeContext} from '../../../themes/ThemeProvider';
import SearchTrigger from './SearchTrigger/index';
// import AddTrigger from "./AddTrigger/index";
import AddBatchTrigger from './AddBatchTrigger/index';
import SaveAlert from '../../../components/DialogBox/SaveAlert';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function TriggerSubTabs() {
  const classes = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [rowSelected, setRowSelected] = useState(false);
  const {setGlobalFieldRow, sample, setNewTabValue} =
  useContext(SelectTabContextProvider);
  // set Tab Value(2700489754)
  const handleTabChange = (event, newValue) => {
    if (value === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setValue(newValue);
    }
    setGlobalFieldRow(false);
  };
  return (
    <div className={`${classes1.cardStyleWhite}`}>
      <div className={classes.root}>
        <div className={classes.subContent}>
          {open && (
            <SaveAlert setTabValue={setValue} setOpen={setOpen} open={open} tabvalue={value} />
          )}
          {value === 0 && <SearchTrigger setValue={setValue} setRowSelected={setRowSelected}/>}
          {value === 1 && <AddBatchTrigger setTabValue={setValue} value={value} handleTabChange={handleTabChange} rowSelected={rowSelected}/>}
        </div>
      </div>
    </div>
  );
}
